import request from '@/config/config'
import {
  doGet,
  doPost
} from '@/api/http'
let path = '/base'
// 获取token
export function getToken (query) {
  return request({
    url: path + '/login/getToken',
    method: 'get',
    params: query
  })
}

// 获取图形验证码
export function getValidateCode (query) {
  return request({
    url: path + '/login/getValidateCode',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

// 登录认证
export function doLogin (data) {
  return request({
    url: '/electricity/login',
    method: 'post',
    data
  })
}

// 退出登录
export function doLogout (query) {
  return request({
    url: '/electricity/logout',
    method: 'get',
    params: query
  })
}

// 获取站点管理员菜单码
export function stationManager (query) {
  return request({
    url: path + '/menu/stationManager',
    method: 'get',
    params: query
  })
}

/**
 * 获取用户权限
 * @param {String}
 */
export function getUserAuthority (query) {
  return request({
    url: '/electricity/menu/getMenus',
    method: 'get',
    params: query
  })
}

// 获取用户权限
export async function getMenus (params) {
  let result = await doGet('/electricity/menu/getMenus', params, false, true)
  return result
}

/**
 * 获取园区信息
 * @param {String} id 默认1
 */
export function getParkInfo (query) {
  return request({
    url: '/base/park/getParkInfo',
    method: 'get',
    params: query
  })
}

/**
 * 获取用户信息
 */
export function getUserByToken (query) {
  return request({
    url: '/base/login/getUserByToken',
    method: 'get',
    params: query
  })
}

/**
 * 获取当前用户信息
 */
export function getUserInfo (query) {
  return request({
    url: '/electricity/detail',
    method: 'get',
    params: query
  })
}
